export const MAIN_BLUE = '#211E41'
export const LOW_WHITE = '#efefef'
export const WHITE = '#ffffff'
